import { createReducer } from 'typesafe-actions';

import {
  TBulkCardCreationsAction,
  BulkCardCreationsActionTypes,
  IBulkCardCreationReportState,
} from '@/features/cards/store/types/bulk-cards-creation.types';

const initialState: IBulkCardCreationReportState = {
  bulkCardCreationReport: null,
  isLoading: false,
};

export const bulkCardCreationReportReducer = createReducer<IBulkCardCreationReportState, TBulkCardCreationsAction>(
  initialState,
)
  .handleType(BulkCardCreationsActionTypes.GET_BULK_CARD_CREATION_REPORT, (state) => ({
    ...state,
    isLoading: true,
    error: undefined,
  }))

  .handleType(BulkCardCreationsActionTypes.GET_BULK_CARD_CREATION_REPORT_FAIL, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.error,
  }))

  .handleType(BulkCardCreationsActionTypes.GET_BULK_CARD_CREATION_REPORT_SUCCESS, (state, action) => ({
    ...state,
    bulkCardCreationReport: action.bulkCardCreationReport,
    isLoading: false,
    error: undefined,
  }));
